export const createStyles = () => ({
  listItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  assignmentCard: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '4px',
    p: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    bgcolor: 'background.paper',
  },
  assignmentCardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  assignmentCardStatus: { ml: 'auto' },
  headerCard: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '8px',
    bgcolor: 'background.paper',
    p: { xs: '16px', md: '24px 16px' },
  },
  headerTitle: { display: 'flex', flexDirection: 'column', gap: '8px' },
  linkedMaterial: { mt: '16px' },
  metadataGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr 1fr', lg: 'repeat(4, minmax(0, 1fr))' },
    gap: { xs: '16px', md: '24px' },
    mt: '24px',
  },
  metadataItem: { display: 'flex', alignItems: 'center', gap: '10px' },
  metadataText: { flex: 1 },
  headerActions: {
    display: 'flex',
    gap: '16px',
    mt: '20px',
    pt: '20px',
    borderTop: '1px solid',
    borderColor: 'divider',
  },
  accordion: {
    height: 48,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    px: '16px',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '8px',
  },
  detailContainer: {
    width: '100%',
    maxWidth: '792px',
    mx: 'auto',
    pt: { xs: 1, md: 3 },
  },
  detailContent: { display: 'flex', flexDirection: 'column', gap: '28px' },
  submissionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  submissionControls: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'flex-start', md: 'center' },
    gap: '16px',
    width: '100%',
  },
  filterControl: { width: { xs: 220, sm: 240 }, flexShrink: 0 },
  searchControl: {
    flex: { md: '0 1 320px' },
    maxWidth: { md: 320 },
    ml: { md: 'auto' },
  },
  accordionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    mt: '8px',
  },
});
